import * as React from "react"
import { AppShell } from "@/components/AppShell"

export function AdminShell({ children, wide = false }: { children: React.ReactNode; wide?: boolean }) {
  return <AppShell wide={wide}>{children}</AppShell>
}
